import { defineMessages } from 'react-intl';

import type { AccountError } from '@/graphql/saleor/api';

import { commonErrorCodeMessages, type FormattedError } from './common';

export const errors = defineMessages({
  activationLinkExpiredOrAlreadyConfirmed: {
    id: `accountConfirm.activationLinkExpiredOrAlreadyConfirmed`,
    defaultMessage:
      'This link has expired. Try to log in to your account or contact our Breitling ambassadors for assistance at {phone} or by email at {email}',
  },
});

export const getAccountConfirmErrorCodeMessage = (
  error: FormattedError<AccountError>,
) => {
  switch (error.code) {
    case 'INVALID':
      return errors.activationLinkExpiredOrAlreadyConfirmed;

    default:
      return commonErrorCodeMessages.unexpectedErrorOccurred;
  }
};
